import { Edit } from 'react-admin'

import CollectionForm from './CollectionCodeForm'

const CollectionEdit = props => {
  return (
    <Edit undoable={false} {...props}>
      <CollectionForm editing />
    </Edit>
  )
}

export default CollectionEdit
